module.exports = __webpack_public_path__ + "static/media/drop_logo.1a29c341.png";